import React from "react";

// function WinnersTestimonials() {
//   const items = [
//     {
//       quote:
//         "Found our forever home in under three weeks.",
//       name: "Ananya Sharma",
//       role: "Homeowner, Gurgaon",
//     },
//   ];

//   const loop = [...items, ...items];

//   return (
//     <section className="ws-testi">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersTestimonials;


export function WinnersTestimonials() {
  const items = [
    { quote: "Found our forever home in under three weeks. The visit experience was unreal.", name: "Ananya Sharma", role: "Homeowner, Gurgaon" },
    { quote: "Most transparent platform I've used. ROI calculations actually held up.", name: "Rohan Mehta", role: "Investor, Noida" },
    { quote: "The city insights helped me invest in the right locality at the right time.", name: "Priya Iyer", role: "Investor, Lucknow" },
    { quote: "Loved the curated approach — felt like a concierge, not a portal.", name: "Karan Singh", role: "Homeowner, Dwarka" },
    { quote: "From shortlist to keys in 6 weeks. Everything just worked.", name: "Meera Joshi", role: "Homeowner, Faridabad" },
    { quote: "Their reels make property hunting feel like Netflix. In a good way.", name: "Aditya Verma", role: "Buyer, Indirapuram" },
  ];
  const loop = [...items, ...items];
  return (
    <section className="ws-testi">
      <div className="ws-testi-inner">
        <div className="ws-testi-head">
          <span className="ws-section-eyebrow">Loved by 10,000+ residents</span>
          <h2 className="ws-section-heading">What our community is saying.</h2>
        </div>
      </div>
      <div className="ws-testi-mask">
        <div className="ws-testi-marquee">
          {loop.map((t, i) => (
            <div className="ws-testi-card" key={i}>
              <div className="ws-testi-stars">★★★★★</div>
              <p className="ws-testi-quote">"{t.quote}"</p>
              <div className="ws-testi-author">
                <div className="ws-testi-avatar">{t.name.charAt(0)}</div>
                <div>
                  <h4>{t.name}</h4>
                  <span>{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}